import request from '@/utils/request'
// 报装申请--报装签约完成情况
export function signFinishChart(params) {
  return request({
    url: '/bzApplyPanel/signFinishChart',
    method: 'get',
    params
  })
}

// 报装申请--报装申请状态统计
export function applyStatusBarChart(params) {
  return request({
    url: '/bzApplyPanel/applyStatusBarChart',
    method: 'get',
    params
  })
}

// 报装申请--安装合同类型占比
export function contractTypeChart(params) {
  return request({
    url: '/bzApplyPanel/contractTypeChart',
    method: 'get',
    params
  })
}

// 报装申请--报装申请趋势
export function applyTrendBarChart(params) {
  return request({
    url: '/bzApplyPanel/applyTrendBarChart',
    method: 'get',
    params
  })
}
